export default `<div class="race-meeting__item">
    <button
            class="button-standard race-meeting__selection race-meeting__selection--qualified"
            data-racename="<%= data.name %>"
            data-uid="<%= data.id %>"
            data-entityid="<%= data.id %>"
            data-name="<%= data.name %>">
        <i class="icon-placeholder"></i>
        <i class="icon-placeholder"></i>
    </button>
</div>`;